module.exports = __webpack_public_path__ + "static/media/over_andes_mototurismo_1.b78d6d03.jpg";